module.exports = __webpack_public_path__ + "img/worksbot_img19121103.17ee9b00.jpg";